import React, { useState, Fragment, useEffect, useMemo } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FaFilePdf } from 'react-icons/fa';
import PDFFieldMapper from './PDFFieldMapper';
import { getFileNameFromUrl, getParamsFromHash } from '@/_helpers';

const SmartPdf = ({ onUploadPdfTemplate, onPdfReady, url, hideAddNewFormElement }) => {
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    useEffect(() => {
        const params = getParamsFromHash();
        if (params && params.accumulationPdfId) {
            setShowModal(true);
        }
    }, []);

    const pdfFileName = useMemo(() => {
        if (!url) {
            return '';
        }
        return getFileNameFromUrl(url);
    }, [url]);

    return (
        <Fragment>
            <Button variant="primary" onClick={() => setShowModal(true)}>
                <FaFilePdf /> Convert your document to online Form (Smart PDF)
                <br />
                {pdfFileName}
            </Button>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Smart PDF</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body" style={{ minHeight: '70vh' }}>
                    <Fragment>
                        <PDFFieldMapper
                            onUploadPdfTemplate={onUploadPdfTemplate}
                            url={url}
                            handleClose={handleClose}
                            onPdfReady={onPdfReady}
                            hideAddNewFormElement={hideAddNewFormElement}
                        />
                    </Fragment>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default SmartPdf;
